export const getClassificationTypeSlug = (type: string): string => {
  const typeMap = {
    US_WORKER_CLASSIFICATION: 'usWorkerClassification',
    GLOBAL_WORKER_CLASSIFICATION: 'globalWorkerClassification',
    IR35: 'ir35',
    UK_SOLE_TRADER_CLASSIFICATION: 'ukSoleTraderClassification',
    NL_WORKER_CLASSIFICATION: 'nlWorkerClassification',
  }
  return typeMap[type as keyof typeof typeMap] || type.toLowerCase()
}

export const getClassificationEditUrl = (
  type: string,
  hireNumber: string,
  currentUrl?: string
): string => {
  const typeSlug = getClassificationTypeSlug(type)
  const baseUrl = `/determinations/${typeSlug}/edit/hire/${hireNumber}?hire=${hireNumber}`

  if (currentUrl) {
    const redirectUri = encodeURIComponent(currentUrl)
    return `${baseUrl}&redirect_uri=${redirectUri}`
  }

  return baseUrl
}
